import EmailNotificationsCard from "./EmailNotificationsCard";
import PushNotificationsCard from "./PushNotificationsCard";
import QuietHoursCard from "./QuietHoursCard";
import styles from "../../../../pages/ClientDashboard/Profile/profile.module.css";

export default function NotificationsTab() {
  return (
    <div className={styles.contentGrid}>
      <div className={styles.contentMain}>
        <EmailNotificationsCard />
        <PushNotificationsCard />
      </div>
      <div className={styles.contentSide}>
        <QuietHoursCard />
      </div>
    </div>
  );
}
